import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { environment } from "src/environments/environment";
import { Environment } from "src/environments/environment.interface";

// Structural directives for gating UI on a build-time environment flag
// (e.g. 'auroraV1'). Unlike sm-tenant-has-facet, these are NOT tenant-scoped:
// the value is baked in at build time, so a flagged feature is revealed to
// every tenant at once. Use for product-wide rollouts like the Aurora rebrand.
// Do NOT use for tenant- or user-level access (use sm-tenant-has-facet /
// sm-permissions for those).
//
// Usage:
//   <div *sm-has-env-flag="'auroraV1'">shown when the flag is on</div>
//   <div *sm-has-not-env-flag="'auroraV1'">shown when the flag is off</div>

@Directive({
    selector: '[sm-has-env-flag]',
    standalone: false
})
export class HasEnvFlagDirective {
    private hasView = false;

    constructor(
        private templateRef: TemplateRef<unknown>,
        private viewContainer: ViewContainerRef)
    {}

    @Input('sm-has-env-flag') set flagKey(key: keyof Environment) {
        this.render(environment[key] === 'true');
    }

    private render(enabled: boolean): void {
        if (enabled && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!enabled && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}

@Directive({
    selector: '[sm-has-not-env-flag]',
    standalone: false
})
export class HasNotEnvFlagDirective {
    private hasView = false;

    constructor(
        private templateRef: TemplateRef<unknown>,
        private viewContainer: ViewContainerRef)
    {}

    @Input('sm-has-not-env-flag') set flagKey(key: keyof Environment) {
        this.render(environment[key] !== 'true');
    }

    private render(disabled: boolean): void {
        if (disabled && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else if (!disabled && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}
